import { z } from 'zod';
import { validatedGet } from '../api-client.ts';
import { DelegaArricchitaSchema } from '@/types/api-responses.ts';
import { buildQueryUrl } from './shared.ts';
import type { PaginatedParams } from './shared.ts';

const PresentazioneConStatsSchema = z.object({
  id: z.number(),
  cassa: z.string(),
  dataPresentazione: z.string(),
  totale: z.number(),
  countPresentate: z.number(),
  countRifiutate: z.number(),
  countArchiviate: z.number(),
  countConfermate: z.number(),
  matchFatto: z.boolean(),
});

const PresentazioniListResult = z.object({
  presentazioni: z.array(PresentazioneConStatsSchema),
});

const DelegheByStatoResult = z.object({
  deleghe: z.array(DelegaArricchitaSchema),
  count: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
});

export const presentazioniApi = {
  lista: () => validatedGet('presentazioni', PresentazioniListResult),

  delegheByStato: (codaId: number, stato: string, opts?: PaginatedParams) =>
    validatedGet(buildQueryUrl(`presentazioni/${codaId}/deleghe?stato=${stato}`, opts), DelegheByStatoResult),

  csvUrl: (codaId: number) => `/api/presentazioni/${codaId}/csv`,
};
